function productBlockHover() {
    if (window.matchMedia("(min-width: 1024px)").matches) {
        const hoverDelay = 100;
        
        const imageContainers = $(".collection__product-block");
        imageContainers.each(function() {
            if ($(this).find(".collection__product-images img").length > 1) {
                this.addEventListener("mouseenter",function() {
                    const images = $(this).find(".collection__product-images img");
                    const text = $(this).find(".collection__price-size").children();

                    $(images[0]).delay(hoverDelay).animate({opacity:0},0);
                    $(text[0]).delay(hoverDelay).hide(0);
                    $(text[1]).delay(hoverDelay).show(0);
                });

                this.addEventListener("mouseleave",function() {
                    const images = $(this).find(".collection__product-images img");
                    const text = $(this).find(".collection__price-size").children();

                    $(images[0]).delay(hoverDelay).animate({opacity:1},0);
                    $(text[1]).delay(hoverDelay).hide(0);
                    $(text[0]).delay(hoverDelay).show(0);
                })
            }
        });
    }
};